<template>
	<div class="row filter-nav align-center">
		<div>
			<div>
				<span
					class="filter-button"
					:class="{ active: filter === 'showAll' }"
					@click="$emit('change-filter', 'showAll')"
					>{{ $t('showAll') }}</span
				>
			</div>
			<div v-for="item in items" :key="item">
				<span class="filter-button" :class="{ active: filter === item }" @click="$emit('change-filter', item)">
					{{ $t(item.toLowerCase()) }}
				</span>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({ items: { type: Array, default: () => [] }, filter: { type: String, default: 'showAll' } });

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.filter-nav {
	margin: 0 auto;

	> div {
		display: flex;
		flex-flow: column wrap;
		text-align: left;
	}

	span {
		cursor: pointer;
		display: inline-block;
		padding: 3px 0;
		text-transform: uppercase;
		margin: 5px 0;
		transition: all 0.3s ease-in-out;
		color: var(--body-color);
		border-bottom: 2px solid rgb(0 0 0 / 0%);
		text-decoration: none;
		font-weight: 700;
		letter-spacing: 1px;
		font-size: var(--body-font-size);

		&.active {
			border-color: var(--body-color);
			color: var(--body-color);
		}
	}
}

@media (max-width: 1080px) {
	.filter-nav {
		margin: 0 auto 20px;

		> div {
			text-align: center;
		}
	}
}
</style>
